import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { TwSeriLogViewModel } from '../serilog.types';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TwSeriLogService } from '../serilog.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-serilog-edit',
    templateUrl: './serilog-edit.component.html',
})
export class SeriLogEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() twSeriLogVM: TwSeriLogViewModel;
    @Input() formGroup: FormGroup;

    isCollapsedCabecera = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private activatedRoute: ActivatedRoute,
        private twSeriLogService: TwSeriLogService,
        private datepipe: DatePipe,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit() {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.twSeriLogVM?.currentValue) {
            this.twSeriLogVM = { ...changes.twSeriLogVM?.currentValue };
            this.updateForm();
        }
    }

    private updateForm(): void {
        this.formGroup.setValue({
            Id: this.twSeriLogVM?.Id || null, // Not visible but required
            Message: this.twSeriLogVM?.Message || '',
            MessageTemplate: this.twSeriLogVM?.MessageTemplate || '',
            Level: this.twSeriLogVM?.Level || '',
            TimeStamp: this.datepipe.transform(this.twSeriLogVM?.TimeStamp, 'dd/MM/yyyy HH:mm:ss') || null,
            Exception: this.twSeriLogVM?.Exception || '',
            Properties: this.twSeriLogVM?.Properties || '',
        });

        this.form = this.formGroup;
    }

    onCopyProperties(inputElement: any) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
    }
}
